import { Skeleton } from "antd"

import styles from "./descriptor-row.module.less"

const DescriptorRowSkeleton = () => (
  <div className={styles.row}>
    <div className={styles.skTop}>
      <Skeleton.Button active style={{ width: 160, height: 15 }} />
      <Skeleton.Button active style={{ width: 84, height: 15 }} />
    </div>
    <Skeleton.Button active block style={{ height: 4, borderRadius: 4 }} />
    <Skeleton.Button active style={{ width: 300, height: 13 }} />
  </div>
)

export default DescriptorRowSkeleton
